import { Box, ButtonBase, SvgIconTypeMap, Typography } from "@mui/material";
import React from "react";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { colors } from "../../theme";

interface settingOption {
    index?: number;
    settingCategory: string;
    icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
    selected?: boolean;
    onSelect?: () => void;
}

export default function SettingOptions(props: settingOption) {
    const { index, settingCategory, icon, selected, onSelect } = props;

    return (
        <ButtonBase
            key={index}
            onClick={onSelect}
            sx={{
                width: "100%",
                justifyContent: "flex-start",
                gap: 1.5,
                px: 1.5,
                py: 1.25,
                mb: 0.5,
                borderRadius: 1.5,
                textAlign: "left",
                backgroundColor: selected ? colors.elevatedHover : "transparent",
                transition: "background-color 120ms ease",
                "&:hover": { backgroundColor: colors.elevatedHover },
            }}
        >
            <Box
                sx={{
                    width: 40,
                    height: 40,
                    borderRadius: 1.5,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    backgroundColor: selected ? colors.accentSoft : colors.elevated,
                    color: selected ? colors.accent : colors.textSecondary,
                }}
            >
                {React.createElement(icon, { style: { width: 22, height: 22 } })}
            </Box>
            <Typography
                sx={{
                    fontWeight: 600,
                    fontSize: 15,
                    color: selected ? colors.textPrimary : colors.textSecondary,
                }}
            >
                {settingCategory}
            </Typography>
        </ButtonBase>
    );
}
